module.exports = "<div class=\"titleBar\">\n    <i\n        class=\"fa fa-chevron-left\"\n        ng-show=\"$ctrl.item.showBackButton\"\n        ng-click=\"$ctrl.onBackButtonClick()\"\n    ></i>\n    <div>{{$ctrl.item.title}}</div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/frontend/modules/root/components/titleBar/titleBar.html
// module id = 362
// module chunks = 0